import firebase from '../firebase'
import 'firebase/storage'
import 'firebase/auth'

const storageRef = firebase.storage().ref()

/**
 * tmporaryディレクトリにアップロードする
 *
 */
export function uploadToTemp(file) {
  const fileName = Math.random()
  const filePath = 'tmp/' + fileName

  const metadata = {
    contentType: file.type,
  }

  const uploadTask = storageRef.child(filePath).put(file, metadata)

  return uploadTask
}

export function uploadAvatar(file) {
  const fileName = Math.random()
  const filePath = 'images/artists/avatars/' + fileName

  const metadata = {
    contentType: file.type,
  }
  const uploadTask = storageRef.child(filePath).put(file, metadata)

  return uploadTask
}
